import {StatusIndicatorMapping, StatusTitleMapping} from "app/services/api/types/residents/enums/ResidentStatusEnum";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { View } from "react-native";
import StatusIndicator from "ui/atoms/avatar/statusIndicator/StatusIndicator";
import ViewMore from "ui/molecules/common/ViewMore";
import { ResidentsPath } from "../../../constants/routePaths";

interface Props {
  resident?: ResidentModel;
}

export default function ResidentActions({ resident }: Props) {
  const ResidentPath = `${ResidentsPath}/${resident?.id}/handover`;

  return (
    <View className="self-end">
      <ViewMore link={ResidentPath} />
      {resident?.status ? (
        <View className="flex flex-col py-3">
          <StatusIndicator
            status={StatusIndicatorMapping[resident.status]}
            statusTitle={StatusTitleMapping[resident.status]}
          />
        </View>
      ) : null}
    </View>
  );
}
